import { blue, red } from "@ant-design/colors";
import { DeleteOutlined } from "@ant-design/icons";
import { Modal, Space, Switch, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { FAQQuestion } from "../../../interfaces/faq.interface";

export type GenerateColumnsOptions = {
  onClickItem: (index: number) => void | PromiseLike<void>;
  onSwitchChange: (index: number, value: boolean) => void | PromiseLike<void>;
  onDeleteItem: (index: number) => void | PromiseLike<void>;
};

const generateColumns = (
  options: GenerateColumnsOptions
): ColumnsType<FAQQuestion> => [
  {
    title: "Question",
    dataIndex: "question",
    key: "question",
    width: "50%",
    ellipsis: true,
    render: (value: string, record, index) => (
      <Typography.Text
        style={{ color: blue.primary, cursor: "pointer" }}
        onClick={() => {
          options.onClickItem(index);
        }}
      >
        {value}
      </Typography.Text>
    ),
  },
  {
    title: "Active",
    dataIndex: "isActive",
    key: "isActive",
    render(value: boolean, _, index) {
      return (
        <Switch
          checked={value}
          onChange={(checked) => options.onSwitchChange(index, checked)}
        />
      );
    },
  },
  {
    title: "Action",
    key: "action",
    render: (_, record: FAQQuestion, index: number) => (
      <Space size="middle">
        <DeleteOutlined
          onClick={() => {
            Modal.confirm({
              title: "Delete Banner",
              content: `Are you sure you want to delete?`,
              icon: <DeleteOutlined />,
              onOk() {
                options.onDeleteItem(index);
              },
            });
          }}
          style={{ color: red.primary }}
        />
      </Space>
    ),
  },
];

export default generateColumns;
